import { useEffect } from 'react';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';

const useDashboardTemplatesReloadEffect = (stableCallback: () => void) => {
  const templateChangeCounter = useDashboardSelector('templateChangeCounter');

  // refetch query to get potential updated list
  useEffect(() => {
    if (templateChangeCounter) {
      stableCallback();
    }
  }, [stableCallback, templateChangeCounter]);
};

export default useDashboardTemplatesReloadEffect;
